import { EmployeeItemInfoData } from '~/components/GenericList/EmployeeItemInfo';
import { OrganizationUnit, ResponsibleEmps } from '~/data/orgunits';

export interface AlternateManagerRow {
  id: string;
  entryId?: string;
  manager: EmployeeItemInfoData | null;
  startDate: string | null;
  endDate: string | null;
  savedWithoutDates: boolean;
}

export interface OrgUnitFormData {
  fOrgUnitName: string;
  fOrgUnitNumber: string;
  fOrgUnitType: string;
  fOrgUnitLoc: number;
  fOrgUnitUrl: string;
  fOrgUnitCreated: string;
  fOrgUnitAvail: string;
  fOrgUnitManager: number;
  fOrgUnitResponsibleEmps: ResponsibleEmps[];
  fOrgUnitContainingTrees: number[];
  fOrgUnitCostCenters: number[];
  substituteManager: ResponsibleEmps | null;
  substituteStartDate: string;
  substituteEndDate: string;
  alternateManagers: AlternateManagerRow[];
  responsibleHRs: ResponsibleEmps[];
  deputyManagers: ResponsibleEmps[];
}

export type OrganizationUnitSubmission = Omit<OrganizationUnit, 'fOrgUnitId'> &
  Partial<Pick<OrganizationUnit, 'fOrgUnitId'>>;

export enum OrgUnitPopupMode {
  New = 'new',
  Edit = 'edit',
  SubstituteEdit = 'substituteEdit',
  Read = 'read',
}
